import apiServices from '../../../services/apiService';

export const roundInspectionApi = {
  // -- Checkpoints & Locations ---------------------------------------------
  getLocations: (siteId, wingId, floorId) => {
    let url = `/round-inspection/locations?siteId=${siteId}`;
    if (wingId) url += `&wingId=${wingId}`;
    if (floorId) url += `&floorId=${floorId}`;
    return apiServices({ url, method: 'GET' });
  },

  getLocationById: (id) =>
    apiServices({ url: `/round-inspection/locations/${id}`, method: 'GET' }),

  createLocation: (data) =>
    apiServices({ url: '/round-inspection/locations', method: 'POST', data }),

  updateLocation: (id, data) =>
    apiServices({ url: `/round-inspection/locations/${id}`, method: 'PUT', data }),

  deleteLocation: (id) =>
    apiServices({ url: `/round-inspection/locations/${id}`, method: 'DELETE' }),

  // -- Checklist Templates ------------------------------------------------
  getTemplates: (siteId) =>
    apiServices({ url: `/round-inspection/templates?siteId=${siteId}`, method: 'GET' }),

  getTemplateById: (id) =>
    apiServices({ url: `/round-inspection/templates/${id}`, method: 'GET' }),

  createTemplate: (data) =>
    apiServices({ url: '/round-inspection/templates', method: 'POST', data }),

  updateTemplate: (id, data) =>
    apiServices({ url: `/round-inspection/templates/${id}`, method: 'PUT', data }),

  deleteTemplate: (id) =>
    apiServices({ url: `/round-inspection/templates/${id}`, method: 'DELETE' }),

  // -- Rounds & Schedules -------------------------------------------------
  getRounds: (siteId, vendorId) => {
    let url = `/round-inspection/rounds?siteId=${siteId}`;
    if (vendorId) url += `&vendorId=${vendorId}`;
    return apiServices({ url, method: 'GET' });
  },

  createRound: (data) =>
    apiServices({ url: '/round-inspection/rounds', method: 'POST', data }),

  updateRound: (id, data) =>
    apiServices({ url: `/round-inspection/rounds/${id}`, method: 'PUT', data }),

  deleteRound: (id) =>
    apiServices({ url: `/round-inspection/rounds/${id}`, method: 'DELETE' }),

  // -- Staff Assignment ---------------------------------------------------
  assignStaff: (data) =>
    apiServices({ url: '/round-inspection/assign-staff', method: 'POST', data }),

  // -- Live Operations & Audit --------------------------------------------
  getLiveVisits: (siteId, roundId, date, vendorId) => {
    let url = `/round-inspection/live-visits?siteId=${siteId}`;
    if (roundId) url += `&roundId=${roundId}`;
    if (date) url += `&date=${date}`;
    if (vendorId) url += `&vendorId=${vendorId}`;
    return apiServices({ url, method: 'GET' });
  },
};
